import { Title } from "apps/batchOnboarding/Title";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { batchProfileBinder } from "libs/analytics/binders/batchOnboarding/batchProfile";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { BatchProfileForm } from "./BatchProfileForm";
import { useBatchProfileDataApi } from "./useBatchProfileDataApi";

export const ProfilePage = () => {
    const {
        cmsData: {
            profile: { profile },
        },
    } = useStaticDataAtomValue();
    const { data, isLoading } = useBatchProfileDataApi();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(batchProfileBinder);

    const page = (
        <VStack gap="24" pb="32">
            <Title title={profile} />
            {isLoading ? <OneOnboardingSkeleton /> : <BatchProfileForm data={data} />}
        </VStack>
    );

    return createPortal(page, document.querySelector("#one-onboarding-portal"));
};
